import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Column, Table } from 'react-virtualized';
import InfiniteList from './InfiniteList';
import _ from 'lodash';
import Api from './Config';

const Div = (props) => {
  if (!props.visible) {
    return null;
  }

  return <div>{props.children}</div>;
};

const REVIEWER_TYPES = ['User', 'Super User', 'Manager', 'Office Admin'];
const REVIEWER_VALUES = ['0', '3', '2', '4'];

const AdminManageReviewers = (props) => {
  const [formMode, setFormMode] = useState('ADD');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [reviewers, setReviewers] = useState([]);

  const [groups, setGroups] = useState([]);
  const [apps, setApps] = useState([]);
  const [selected_club, setSelectedClub] = useState(null);
  const [reviewerType, setReviewerType] = useState(0);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [initials, setIniitals] = useState('');
  const [first_name, setFirstName] = useState('');
  const [last_name, setLastName] = useState('');
  const [id, setId] = useState(0);
  const [clusters, setClusters] = useState([]);
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [reloadList, setReloadList] = useState(0);

  useEffect(() => {
    Api.getApps(false).then((apps) => {
      let allApps = _.map(apps, (a) => {
        a.clubname = unescape(a.clubname);
        return a;
      });
      allApps = _.orderBy(allApps, ['clubname']);
      setApps(allApps);
      Api.getAllClusters().then((items) => {
        setClusters(items.data);
      });
    });
  }, []);

  const getReviewers = (club_id_or_cluster_id) => {
    setSelectedItem(club_id_or_cluster_id);
    setReloadList(reloadList + 1);
  };

  const loadRows = async (startIdx, queryAmount) => {
    const results = await Api.getAllReviewers(selectedItem, reviewerType, startIdx, queryAmount);
    let newReviewers = results.data;
    if (startIdx > 0) {
      newReviewers = reviewers.concat(newReviewers);
    }
    setReviewers(newReviewers);

    return {
      data: results.data,
      maxRows: results.maxRows,
    };
  };

  const onUserNameSave = () => {
    const cluster_id = _.get(selectedCluster, 'id', null);

    Api.insertReviewer(
      username,
      password,
      _.get(selected_club, 'club_id', null),
      reviewerType,
      _.get(selectedGroup, 'group_code', null),
      initials,
      first_name,
      last_name,
      formMode,
      id,
      cluster_id
    )
      .then(({ result, error }) => {
        if (!result) {
          alert(error);
          return;
        }
        getReviewers(hasCluster(reviewerType) ? cluster_id : selected_club.club_id);

        if (formMode == 'ADD') {
          alert('Reviewer created successfully');
        } else {
          alert('Changes saved successfully');
        }
        clearForm(false);
      })
      .catch((err) => {
        alert(`${err}`);
      });
  };

  const itemSelected = (obj) => {
    setSelectedClub(obj);
    setSelectedGroup(null);
    getReviewers(obj.club_id);
    Api.getAllGroups(obj.club_id).then((item) => {
      setGroups(item.data);
    });
  };

  const doDelete = (row) => {
    if (confirm(`are you sure you want to delete ${row.username}?`)) {
      Api.deleteReviewer(row.id)
        .then(() => {
          const cluster_id = _.get(selectedCluster, 'id', null);
          getReviewers(hasCluster(reviewerType) ? cluster_id : selected_club.club_id);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const clearForm = (clearType = true) => {
    setFormMode('ADD');
    setFirstName('');
    setLastName('');
    setSelectedGroup(null);
    setIniitals('');
    clearType && setReviewerType(0);
    setReviewers([]);
    setUsername('');
    setPassword('');
    setId(0);
  };

  const showAllClusterAdmin = (reviewerType) => {
    setReviewerType(reviewerType);
    getReviewers(null);
  };

  const clusterSelected = (cluster) => {
    setSelectedCluster(cluster);
    getReviewers(cluster.id);
  };

  const hasCluster = (reviewerType) => {
    if (reviewerType == Api.ROLE_SUPER || reviewerType == Api.ROLE_MANAGER) {
      return true;
    }

    return false;
  };

  const getTableCell = ({ cellData, dataKey, rowData, rowIndex }) => {
    let cellItem;

    switch (dataKey) {
      case 'reviewer_type':
        cellItem = REVIEWER_TYPES[REVIEWER_VALUES.indexOf(cellData)];
        break;
      case 'cluster_app':
        cellItem = `${rowData.app_id || ''} ${rowData.cluster_name || ''}`;
        break;
      case 'name':
        cellItem = `${rowData.first_name || ''} ${rowData.last_name || ''}`;
        break;
      case 'action':
        cellItem = (
          <React.Fragment>
            <button
              className="btn btn-info"
              type="button"
              style={{ marginRight: 20 }}
              onClick={() => {
                setFormMode('Edit');
                setFirstName(rowData.first_name);
                setLastName(rowData.last_name);
                setSelectedGroup({ group_code: rowData.group_code });
                setIniitals(rowData.initials);
                setReviewerType(rowData.reviewer_type);
                setUsername(rowData.username);
                setPassword(Api.NO_CHANGE);
                setSelectedCluster(clusters.find((a) => a.id == rowData.cluster_id));
                setId(rowData.id);
              }}
            >
              Edit
            </button>
            <button
              type="button"
              onClick={(e) => {
                doDelete(rowData);
              }}
              className="btn btn-danger"
            >
              Delete
            </button>
          </React.Fragment>
        );
        break;
    }

    return cellItem;
  };

  return (
    <div>
      <div className="form-group" style={{ maxWidth: 400, marginBottom: 40 }}>
        <label>Reviewer Type</label>
        <select
          value={reviewerType}
          disabled={formMode == 'Edit'}
          onChange={(e) => {
            setReviewerType(e.target.value);
            setSelectedCluster(null);
            setSelectedClub(null);
            setReviewers([]);
            clearForm(false);
            if (hasCluster(e.target.value)) {
              showAllClusterAdmin(e.target.value);
            }
          }}
          className="form-control"
        >
          {REVIEWER_TYPES.map((a, index) => {
            //  if(index===1)
            // {
            //  return ;
            //  }
            return (
              <option value={REVIEWER_VALUES[index]} key={a}>
                {a}
              </option>
            );
          })}
        </select>
      </div>

      {!hasCluster(reviewerType) && (
        <div style={{ maxWidth: 400, marginBottom: 40 }}>
          <label>Select App:</label>
          <Select
            isDisabled={formMode == 'Edit'}
            onChange={itemSelected}
            value={selected_club}
            getOptionValue={(a) => a.club_id}
            getOptionLabel={(a) => a.clubname}
            options={apps}
          />
        </div>
      )}

      {hasCluster(reviewerType) && (
        <div style={{ maxWidth: 400, marginBottom: 40 }}>
          <label>Select Cluster:</label>
          <Select
            onChange={clusterSelected}
            value={selectedCluster}
            isDisabled={formMode == 'Edit'}
            getOptionValue={(a) => a.id}
            getOptionLabel={(a) => a.cluster_name}
            options={clusters}
          />
        </div>
      )}

      <Div visible={true}>
        <div style={{ display: 'flex' }}>
          <div className="panel panel-default" style={{ width: 400 }}>
            <div className="panel-heading">{formMode == 'ADD' ? 'Add' : 'Edit'} Credentials</div>
            <div className="panel-body">
              <div className="form-group">
                <label>Username</label>
                <input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={formMode == 'ADD' ? false : true}
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="text"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control"
                />
              </div>

              <hr />
              <div className="form-group">
                <label>First Name</label>
                <input
                  type="text"
                  value={first_name}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  value={last_name}
                  onChange={(e) => setLastName(e.target.value)}
                  className="form-control"
                />
              </div>

              <Div visible={true}>
                <label>Initials</label>
                <input
                  type="text"
                  value={initials}
                  onChange={(e) => setIniitals(e.target.value)}
                  className="form-control"
                  maxLength={5}
                  maxWidth={5}
                  size={5}
                  style={{ width: 80 }}
                />
              </Div>

              <Div visible={false} className="form-group">
                <label>Group</label>
                <Select
                  value={selectedGroup}
                  onChange={(obj) => {
                    if (obj) {
                      setSelectedGroup(obj);
                    } else {
                      setSelectedGroup(null);
                    }
                  }}
                  getOptionValue={(a) => a.group_code}
                  getOptionLabel={(a) => a.group_code}
                  options={groups}
                />
              </Div>
            </div>

            <div className="panel-footer" style={{ display: 'flex', justifyContent: 'center' }}>
              <button type="button" onClick={onUserNameSave} className="btn btn-primary">
                {formMode === 'ADD' ? 'Add Credentials' : 'Save Changes'}
              </button>

              <button
                style={{ marginLeft: 10 }}
                type="button"
                onClick={() => {
                  clearForm();
                }}
                className="btn btn-info"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>

        <div>
          <InfiniteList lists={reviewers} loadRows={loadRows} reloadList={reloadList}>
            {({ onRowsRendered, registerChild, width }) => (
              <Table
                ref={registerChild}
                onRowsRendered={onRowsRendered}
                width={width}
                height={800}
                headerHeight={40}
                rowStyle={{
                  borderBottom: '1px solid #ddd',
                  paddingTop: 5,
                  paddingBottom: 5,
                }}
                rowHeight={50}
                rowCount={reviewers.length}
                rowGetter={({ index }) => reviewers[index]}
              >
                <Column label="Username" dataKey="username" width={width / 4} />
                <Column label="Reviewer Type" dataKey="reviewer_type" cellRenderer={getTableCell} width={width / 8} />
                <Column
                  label={hasCluster(reviewerType) ? 'Cluster' : 'App'}
                  dataKey="cluster_app"
                  cellRenderer={getTableCell}
                  width={width / 6}
                />
                <Column label="Initials" dataKey="initials" width={width / 8} />
                <Column label="Name" dataKey="name" cellRenderer={getTableCell} width={width / 4} />
                <Column label="" dataKey="action" cellRenderer={getTableCell} width={width / 7} />
              </Table>
            )}
          </InfiniteList>
        </div>
      </Div>
    </div>
  );
};

export default AdminManageReviewers;
